<template>
  <section :class="['invite-list', taskDimension && 'invite-list__tile']">
    <h3 class="title">{{ inviteName }}</h3>
    <section
      class="invite-container"
      @scroll="scrollRefresh"
      ref="scrollContain"
      v-if="inviteRecords.length > 0"
    >
      <ul ref="scroll">
        <li
          :class="['list-item']"
          v-for="(item, num) in inviteRecords"
          :key="num"
        >
          <section class="content-title" v-if="!taskDimension">
            <p class="item-user">
              <img src="../assets/images/icon_user.png" alt="" />
              {{ item.inviteeCellPhone }}
            </p>
            <p
              :class="[
                'item-status',
                taskStatus(item.status),
                activeInviteId === num && 'active'
              ]"
            >
              {{ item.status | taskText }}
              <span class="img-wrapper" @click="setActiveInviteId(item, num)">
                <img src="../assets/images/icon_normal_arrow.png" alt="" />
              </span>
            </p>
          </section>
          <ul
            :class="[
              'content-detail',
              ((activeInviteId === num && item.taskInfos.length > 0) ||
                taskDimension) &&
                'active'
            ]"
          >
            <template v-for="(task, index) in item.taskInfos">
              <RecrodItem
                :task="task"
                :key="index"
                :user="item.inviteeCellPhone"
                :taskDimension="taskDimension"
              />
            </template>
          </ul>
        </li>
      </ul>
      <p v-if="isEnd" class="no-more">没有更多了～</p>
    </section>
    <section v-else class="invite-empty">
      <img
        class="xl_empty"
        src="../assets/images/no_trip.png"
        alt=""
        v-if="isXl"
      />
      <img class="hll_empty" src="../assets/images/empty.png" alt="" v-else />

      <p class="desc">您还没有任何邀请明细哦～</p>
    </section>
  </section>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import RecrodItem from './RecordItem';
import { getInviteRecord } from '../api/index';
import { isXL } from '../utils';
const PAGE_SIZE = 10;

export default {
  components: { RecrodItem },
  data() {
    return {
      activeInviteId: -1,
      inviteRecords: [],
      loading: false,
      page: 1,
      totalSize: 0
    };
  },
  props: ['taskDimension'],
  mounted() {
    console.log(this.taskDimension, 'list-->props');
  },
  computed: {
    ...mapState('app', ['activityCode', 'city_id', 'position', 'businessType']),

    isEnd() {
      return this.page >= this.totalSize;
    },
    isXl() {
      return isXL();
    },
    inviteName() {
      return !this.taskDimension ? '邀请任务状态' : '邀请明细';
    }
  },
  filters: {
    taskText(status) {
      if (status == 0) {
        return '进行中';
      } else if (status === 1) {
        return '已成功';
      } else {
        return '已失效';
      }
    },
    endTime(time) {
      let Month = new Date(time).getMonth() + 1;
      let Day = new Date(time).getDate();
      return `${Month}.${Day}过期`;
    }
  },
  created() {
    this.fetchRecords(this.page);
  },
  methods: {
    ...mapMutations('app', ['setInviteRecords']),
    ...mapActions('app', ['fetchRecordsInfo']),
    taskStatus(status) {
      if (status == 0) {
        return 'inprogress';
      } else if (status == 1) {
        return 'success';
      } else {
        return 'failure';
      }
    },
    async scrollRefresh() {
      if (this.loading) {
        return;
      }
      // 后续需要优化，每次都要计算高度
      // 被卷去的高度+父容器高度=滚动内容高度 此时触发
      let scrollContentHeight = this.$refs.scroll.scrollHeight; // 滚动内容的总高度
      let scrollHeight = this.$refs.scrollContain.scrollTop; // 被卷去的高度
      let containerHeight = this.$refs.scrollContain.offsetHeight; // 容器高度
      let result = scrollContentHeight - (scrollHeight + containerHeight);
      // 10为距离底部多高开始出发事件
      if (result <= 10 && !this.loading && !this.isEnd) {
        this.loading = true;
        this.page++;
        // 拉取数据
        await this.fetchRecords(this.page);
        this.loading = false;
      }
    },
    async fetchRecords(page) {
      // this.fetchRecordsInfo({ page });
      this.$hll.showLoading({ disableLogo: this.isXl });
      let recordData = [];
      try {
        recordData = await getInviteRecord({ page });
      } catch (error) {
        throw error;
      } finally {
        this.$hll.hideLoading();
      }
      this.inviteRecords = [
        ...this.inviteRecords,
        ...recordData.inviteeInfoList
      ];
      this.totalSize = Math.ceil(recordData.total / PAGE_SIZE);
    },
    async setActiveInviteId(item, num) {
      console.log(item);
      if (this.activeInviteId === num) {
        this.activeInviteId = -1;
      } else {
        this.activeInviteId = num;
        this.trackLog('邀请记录状态', false, {
          actEventType: 'invite_invitestatus_click'
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.invite-list {
  // background: #fff7e9;
  // background-color: #fff7e9;
  background-color: #fff;

  border-radius: 32px;
  padding: 30px;
  font-family: Source Han Sans SC Bold, Source Han Sans SC Bold-Bold;

  > .title {
    font-size: 32px;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 500;
    color: #ff5926;
    line-height: 60px;
  }
  .invite-container {
    max-height: 500px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
    }
    > ul {
      .list-item {
        margin: 28px 0;
        font-size: 32px;
        font-weight: 500;
        border-bottom: 1px solid #f9e6c7;
        > .content-title {
          margin-bottom: 15px;
          .fc;
          justify-content: space-between;
          .item-user {
            .fc;
            justify-content: flex-start;
            color: #181d37;
            > img {
              width: 52px;
              height: 52px;
              opacity: 1;
              margin-right: 8px;
            }
          }
          .item-status {
            .fc;
            .img-wrapper {
              width: 41px;
              height: 41px;
              border-radius: 12px;
              background-color: #fff1de;
              margin-left: 15px;
              .fc;
              > img {
                width: 18px;
                transition: all 500ms;
              }
            }
            &.success {
              color: #21c59d;
            }
            &.inprogress {
              color: #ff4e00;
            }
            &.failure {
              color: rgba(24, 29, 55, 0.65);
            }
            &.active {
              .img-wrapper {
                > img {
                  transform: rotate(-180deg);
                }
              }
            }
          }
        }
        .content-detail {
          margin-bottom: 15px;
          max-height: 0px;
          overflow-y: scroll;
          transition: max-height 0.5s;
          &::-webkit-scrollbar {
            display: none;
            width: 0;
          }
          &.active {
            max-height: 400px;
          }
        }
      }
    }
  }
  .no-more {
    text-align: center;
    padding-top: 20px;
  }
  &.invite-list__tile {
    background-color: #fff;
    padding: 0px;
    > .title {
      font-size: 38px;
      font-weight: 500;
      color: #ff5926;
    }
    .invite-container {
      > ul {
        .list-item {
          margin: 0px;
          border-bottom: 0;
          .content-detail {
            margin: 0px;
          }
        }
      }
    }
  }
  .invite-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 70px 0 40px;
    > .hll_empty {
      margin-bottom: 50px;
      width: 235px;
    }
    .xl_empty {
      width: 392px;
      margin-bottom: 25px;
    }
    .desc {
      font-size: 28px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      font-weight: 400;
      text-align: center;
      color: #8c8c8c;
    }
  }
}
</style>
